
export const DataServerBaseUrl = (() => {
    const host = window.location.host;
    return ((host === "aksje.io") ? true : (host === "www.aksje.io")) ? "https://data.aksje.io" : "http://localhost:8086";
})();

